import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { useCallerState } from "../callerState";
import { useLinkedCallerState } from "../linkedCallerState";
import { ProgramView } from "../components/ProgramView";

export function ProgramDetail() {
  const { slug } = useParams({ from: "/app/directory/programs/$slug" });
  const search = useSearch({ from: "/app/directory/programs/$slug" });
  const navigate = useNavigate({ from: "/directory/programs/$slug" });
  const caller = useCallerState();
  // The program for the caller's state (the top bar's), however the rep got here: a state in the link becomes the
  // caller's on arrival, the page's select sets the caller's state, and the link follows it, replaced.
  const state = useLinkedCallerState(search.state, (s) => navigate({ search: { state: s }, replace: true }));
  return <ProgramView slug={slug} state={state} onStateChange={caller.setState} />;
}
